import { render, staticRenderFns } from "./ApplicationInfo.vue?vue&type=template&id=6b0de482&scoped=true&"
import script from "./ApplicationInfo.vue?vue&type=script&lang=js&"
export * from "./ApplicationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0de482",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b0de482')) {
      api.createRecord('6b0de482', component.options)
    } else {
      api.reload('6b0de482', component.options)
    }
    module.hot.accept("./ApplicationInfo.vue?vue&type=template&id=6b0de482&scoped=true&", function () {
      api.rerender('6b0de482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/widgets/ApplicationInfo.vue"
export default component.exports